/*
TeacherManager - Handles adding or denying teachers trying to access the Math Grading application. Need to add functionality so it can only be accessible be admin.

*/

import React, { useState } from "react";
import Table from "./Table";
import { Form, Button } from "react-bootstrap";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { removeTeacher, updateTeacherInfo } from "../control/TeacherData";
import ButtonGroup from 'react-bootstrap/ButtonGroup';

function TeacherManager(props){
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});

    useEffect(() => {
        // Sets the filtered data to the data from firebase
        setFilteredData(props.data);
    }, [props.data]);

    //filtering data by teacher name and their email
    const filterData = (search) => {
        const searchTerm = search.target.value.toLowerCase();
        const filtered = props.data.filter(
        (item) =>
            searchCheck(item.name, searchTerm) ||
            searchCheck(item.email, searchTerm),
        );
        setFilteredData(filtered);
    };

    // Checks if the value is a string and if it includes the search term
    const searchCheck = (value, searchTerm) => {
        if (typeof value === "string" && value !== null && value !== undefined) {
            return value.toLowerCase().includes(searchTerm);
        }
        return false;
    };

    //iterating through the selectedItems array, calling updateTeacherInfo to change each teachers verified status to true
    const confirmTeacher = () => {
        if (Object.keys(selectedItems).length > 0) {
            Object.keys(selectedItems).forEach((key) => {
                updateTeacherInfo(selectedItems[key].id);
            });
        }
        else{
            alert("You have not selected any teachers to approve!");
        }
    };

    //iterating through selectedItems array, calling removeTeacher to remove their account in the database, which will also remove them from the table
    const denyTeacher = () => {
        if (Object.keys(selectedItems).length > 0) {
            Object.keys(selectedItems).forEach((key) => {
                removeTeacher(selectedItems[key].id);
            });
        }
        else{
            alert("You have not selected any teachers to deny!");
        }
    };

    return (
        <div className="container" {...props}>
            <h2>{props.title}</h2>
            <Form.Control
                type="text"
                placeholder="Search Teachers"
                onChange={(search) => filterData(search)}
                style={{ width: "300px" }}
            />
            <div className="d-flex justify-content-between align-items-center mb-3">

                <div
                style={{ margin: "20px 0 20px 0" }}
                className="d-flex align-items-end">

                <ButtonGroup>
                    <Button
                    variant="primary"
                    onClick={confirmTeacher}
                    >
                    Confirm Teacher(s)
                    </Button>
                    <Button
                    variant="danger"
                    onClick={denyTeacher}
                    >
                    Deny Teacher(s)
                    </Button>
                    <Button
                    variant="primary"
                    onClick={() => navigate("/faculty/dashboard")}
                    >
                    Back to Dashboard
                    </Button>
                </ButtonGroup>
            </div>

        </div>

        {!filteredData.length && <p>No Teachers Pending Approval</p>}
        {filteredData.length && (
        <div className="mx-auto" style={{ maxWidth: "100%" }}>
          <Table data={filteredData} hiddenColumns={['id']} showCheckboxes={true} selectedItems={selectedItems}/>
        </div>
        )}
        </div>
    );
}

export default TeacherManager;